import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const stats = [
  { value: 20000, label: "SERVICE PROJECTS" },
  { value: 35, label: "TYPES OF SERVICES", suffix: "+" },
  { value: 253, label: "EXPERT HANDYMAN" },
  { value: 100, label: "CLIENT'S SATISFACTION", suffix: "%" },
];

const StatsCounter = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Start counting only once
    threshold: 0.5, // Start animation when 50% of the component is visible
  });

  return (
    <div ref={ref} className="stats-container">
      {stats.map((stat, index) => (
        <div key={index} className="stat-item">
          <h2 className="stat-number">
            {inView ? <CountUp start={0} end={stat.value} duration={2} suffix={stat.suffix || ""} /> : 0}
          </h2>
          <p className="stat-label">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsCounter;
